import { makeAction, makeReducer } from '@finn-no/redux-actions';
import type { AppState } from '../interfaces';

export const actions = {
    openFilter: makeAction<AppState>('OPEN_FILTERS', (state, action) => ({ ...state, filtersOpen: action.payload })),
    setMapMode: makeAction<AppState>('SET_MAP_MODE', (state, action) => ({ ...state, isMapMode: action.payload })),
};

export default actions;
export const appStateReducer = makeReducer<AppState>(actions);
